import { createPerimeter } from 'vue-kindergarten';

import store from '@/store';
export default createPerimeter({
  purpose: 'account',

  can: {
    read(){
      return true;
    },
    accessProfileInvoices : () => {
      return store.getters['user/isAdmin'] || store.getters['user/isFreelancer'];
    },
    accessInvoices : () => {
      return store.getters['user/isAdmin'] || store.getters['user/isSubAdmin'] || store.getters['user/isFranchise'] || store.getters['user/isFreelancer'];
    },
    accessSubscriptions : (/** @type {any} */ id) => {
      if(store.state.user.data.id === id && (store.getters['user/isAdmin'] || store.getters['user/isSubAdmin'] || store.getters['user/isFranchise']) ){
        return false;
      }
      return store.getters['user/isAdmin'] || store.getters['user/isSubAdmin'] || store.getters['user/isFranchise'] || store.getters['user/isFreelancer'];
    },
    accessWorkorders : (/** @type {any} */ id) => {
      if(store.state.user.data.id === id && (store.getters['user/isAdmin'] || store.getters['user/isSubAdmin'] || store.getters['user/isFranchise']) ){
        return false;
      }
      return store.getters['user/isAdmin'] || store.getters['user/isSubAdmin'] || store.getters['user/isFranchise'] ||  store.getters['user/isFlexAgency'] || store.getters['user/isFreelancer'] || store.getters['user/isTemp'];
    },
    accessAgreements : (/** @type {any} */ id) => {
      if(store.state.user.data.id === id && (store.getters['user/isAdmin'] || store.getters['user/isSubAdmin'] || store.getters['user/isFranchise']) ){
        return false;
      }
      return store.getters['user/isAdmin'] || store.getters['user/isSubAdmin'] || store.getters['user/isFranchise'] ||  store.getters['user/isFlexAgency'] || store.getters['user/isFreelancer'] || store.getters['user/isTemp'];
    },
    createWorkorder: () => {
      return store.getters['user/isAdmin'] || (store.getters['user/isFreelancer'] && store.getters['user/hasPayedSubscription']) || store.getters['user/isTemp'];
    },
    createInvoice: () => {
      return  store.getters['user/isAdmin'] || store.getters['user/isSubAdmin'] || store.getters['user/isFranchise'] || (store.getters['user/isFreelancer'] && store.getters['user/hasPayedSubscription']) || store.getters['user/isTemp'];
    },
    companyApprove(){
      return store.getters['user/isManager'] || store.getters['user/isHRManager'] ||  store.getters['user/isPlanner']; 
    },
    hasElevatedRights: () => {
       return ( store.getters['user/isAdmin'] || store.getters['user/isSubAdmin'] || store.getters['user/isFranchise']);
    }
  },

  isBusiness(){
    return store.getters['user/isFreelancer'];
  },
  isUser(){
    return store.getters['user/isTemp'] || store.getters['user/isFreelancer'];
  },
  isAdmin(){
    return store.getters['user/isAdmin'];
  },
  isPlanner() {
     return store.getters['user/isPlanner'];
  },
  isManager() {
      return store.getters['user/isManager'];
  },
  isHRManager() {
    return store.getters['user/isHRManager'];
  },
  isFlexAgency() {
    return store.getters['user/isFlexAgency'];
  },
  isFranchise() {
     return store.getters['user/isFranchise'];
  },
  isSubAdmin() {
     return store.getters['user/isSubAdmin'];
  },
  isRegular(){
      return !( store.getters['user/isAdmin'] || store.getters['user/isSubAdmin'] || store.getters['user/isFranchise']);
  },
  isElevated(){
     return ( store.getters['user/isAdmin'] || store.getters['user/isSubAdmin'] || store.getters['user/isFranchise']);
  },

  isRole(role, roles) {
    if(roles){
      var first = roles[0].name;
      return first === role;
    }

    return false;
  },



  expose: [
    'isBusiness',
    'isUser',
    'isAdmin',
    'isPlanner',
    'isManager',
    'isHRManager',
    'isFlexAgency',
    'isFranchise',
    'isSubAdmin',
    'isRegular',
    'isElevated',
    'isRole'
  ],
});


// WEBPACK FOOTER //
// ./src/permissions/accountPerimeter.js